// extracted by css-extract-rspack-plugin
export default {"option":"select-list__option___vkl6f"};